import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import LineChats from './LineChats';
import Skeleton from 'react-loading-skeleton';
import TableData from './TableData';
import ExportDayWise from '../layout/ExportDayWise';

const UserLableDatePickerFullTracking = (props) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  const formatDateToISO = (dateString) => {
    // Convert the input string to a Date object
    const date = new Date(dateString);
  
    // // Check if the date is valid
    // if (isNaN(date)) {
    //   throw new Error(`Invalid date: ${dateString}`);
    // }
  
    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
  
    // Return in YYYY-MM-DD format
    return `${year}-${month}-${day}`;
  }

  const baseurlFaqs = `${process.env.REACT_APP_SERVER_URL}/aipd/trackingTimedByUser?start=${startDate.toLocaleDateString('en-US')}&end=${endDate.toLocaleDateString('en-US')}&email=${props.email}`;
  const baseurlByDate = `${process.env.REACT_APP_SERVER_URL}/aipd/viewsPerReportByPersonaWithTimeForEmail?startDate=${formatDateToISO(startDate)}&endDate=${formatDateToISO(endDate)}&email=${props.email}`;
  // http://localhost:8080/aipd/viewsPerReportByPersonaWithTimeForEmail?startDate=2024-10-21&endDate=2024-11-21&email=nabasundarr@aaysinsight.com
  // const baseurlByDate = `${process.env.REACT_APP_SERVER_URL}/aipd/viewsPerReportByPersonaWithTime?startDate=${formatDateToISO(startDate)}&endDate=${formatDateToISO(endDate)}`;

  const [dataItems, setData] = useState();
  const [DataLoading, setDataLoading] = useState(true);
  const [isLoading, setisLoading] = useState(true);

  const [dataItems1, setData1] = useState();
  const [DataLoading1, setDataLoading1] = useState(true);
  const [isLoading1, setisLoading1] = useState(true);


  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const GetFaqsLsit = async () => {
    setisLoading(true)

    try {
      const response = await fetch(baseurlFaqs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setData(...jsonData);
        setDataLoading(false)
        setisLoading(false);
      } else {
        setData([]);
        setisLoading(false);
        
      }
    } catch (err) {
      console.error("Error:", err);
      setisLoading(false);
      setData([]);
    }
  };

  const GetuserbyDate = async () => {
    setisLoading1(true)

    try {
      const response = await fetch(baseurlByDate, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setData1(jsonData);
        setDataLoading1(false)
        setisLoading1(false);
      } else {
        setData1([]);
        setisLoading1(false);
        
      }
    } catch (err) {
      console.error("Error:", err);
      setisLoading1(false);
      setData1([]);
    }
  };


  useEffect(() => {
 
    GetFaqsLsit();
    GetuserbyDate()
  }, [passtoken, baseurlFaqs]);



  return (
    <div style={{ display: "grid",gridGap:"1rem" }}>
    
      <div style={{ display: "flex", gridGap: "1rem" }}>
        <div id="datepickerID">
          <DateRangePicker
            ranges={[
              {
                startDate,
                endDate,
                key: "selection",
              },
            ]}
            onChange={handleSelect}
          />
          {/* <p>Start Date: {startDate && startDate.toLocaleDateString("en-US")}</p>
      <p>End Date: {endDate && endDate.toLocaleDateString("en-US")}</p> */}
        </div>

        <div style={{ width: "100%" }}>
          {/* <TableData dataLoading={DataLoading} data={dataItems} /> */}

          {isLoading && (
            <div>
              <Skeleton height="400px" />
              {/* <span style={{ paddingTop: "10px", display: "block" }}>
                      Thank you for your patience! We're in the process of gathering
                      the data needed to create your graph
                    </span> */}
            </div>
          )}

          {!isLoading && (
            <div
              style={{
                border: "1px solid #eee",
                display: "grid",
                width: "100%",
                padding: "1rem",
                borderRadius: "6px",
              }}
            >

<div>
                  <ExportDayWise
                    excelData={dataItems1}
                    fileName={`${props.email}_${new Date().getTime()}`}
                  />
                </div>
              <LineChats dataLoading={DataLoading} jsonData={dataItems} />
              {/* <BarChats  dataLoading={DataLoading} data={dataItems}/> */}
            </div>
          )}
        </div>
      </div>

      <div>
        {isLoading && (
          <div>
            <Skeleton height="400px" />
            {/* <span style={{ paddingTop: "10px", display: "block" }}>
              Thank you for your patience! We're in the process of gathering the
              data needed to create your graph
            </span> */}
          </div>
        )}

        {!isLoading && (
          <div
            style={{
              border: "1px solid #eee",
              display: "grid",
              width: "100%",
              padding: "1rem",
              borderRadius: "6px",
            }}
          >
            <TableData dataLoading={DataLoading} data={dataItems} />
            {/* <BarChats  dataLoading={DataLoading} data={dataItems}/> */}
          </div>
        )}
      </div>

      <div>

      </div>
    </div>
  );
};

export default UserLableDatePickerFullTracking;
